import React from "react";
import { EntitySignContextInterface } from "module/entity/context/sign/EntitySignContext";

export type CertificationSignContextInterface = EntitySignContextInterface;

const CertificationSignContext = React.createContext(
  <CertificationSignContextInterface>{}
);

export default CertificationSignContext;
